import React, { useState, useEffect, useContext, Component } from "react";
import "./login.css";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
//import Buttons from "../../toolkit/ButtonV1";
// import Carousel from '../../reusable-components/carousel/Carousel';
import Carousel from "../../reusable-components/carousel/Carousel";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import HelpIcon from "@mui/icons-material/Help";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Img from "../../Media/workerImage.png"
import axios from "../../utils/fvAxios";

import Select from "@mui/material/Select";
import Footer from "../../reusable-components/footer/footer";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BaseUrl from "../../utils/base-uri.json";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Stack, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import i18n from "i18next";

import changeLocale from "../../Localization/changeLocale";
import LocaleContext from "../../Localization/LocaleContext";

import {
  setToken, setEmail, setUserName, setGlobalClientId, setstatuses, setOrgType, setLocalMenus, removeIncognitoEmail, setOrgId, setisEmp, getisEmp,
  getInvitationURL, getInvitationVendorId, getInvitationClientId, getInvitationIsMultiClient, getInvitationPqid
} from "../../utils/Token";
import Work from "../../Media/workerImage.png";
import apiinfo from "../../utils/base-uri.json";
import Loginhelp from "../loginhelp/Loginhelp";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Login({ ...props }) {
  const params = new URLSearchParams(window.location.search);
  const isRegistered = params.get("registered");
  if (isRegistered === "success") {
    window.history.pushState({}, "", "/");
    toast.success("Registration Succesfull", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }

  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [tokenValue, setTokenValue] = React.useState("");
  const [carouselFlag, setCarouselFlag] = React.useState(false);
  const [loginLanguage, setLoginLanguage] = React.useState(props.content);
  const [phoneNumberCode, setPhoneNumberCode] = React.useState("us");
  const [openError, setOpenError] = React.useState(false);
  const [error, setError] = React.useState(null);


  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const { t } = useTranslation();
  const { locale } = useContext(LocaleContext);

  function changeLocale() {
    if (i18n.language == "en")
      i18n.changeLanguage("ar");
    else
      i18n.changeLanguage("en");

  }
  const ChangeL = () => {
    changeLocale();
  };

  // const validationSchema = Yup.object().shape({
  //   userName: Yup.string()
  //     .required("User name is required !")
  //     .max(200, "User name must not exceed 200 characters"),
  //   password: Yup.string().required("Password is required !"),
  // });
  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm({ resolver: yupResolver(validationSchema) });

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpenError(false);
    setOpen(false);
  };



  // const handlePhoneCheck = (val) => {
  //   setPhoneNumberCode(val);
  // };
  const [UserName, setUsername] = React.useState("");
  const [UserNameErr, setUserNameErr] = React.useState("");
  const [Password, setPassword] = React.useState("");
  const [PasswordErr, setPasswordErr] = React.useState("");
  const ChangeUserName = (e) => {
    if (e == "") {
      setUserNameErr("User name is required !");
      setUsername(e);
    } else if (e.length > 200) {
      setUserNameErr("User name must not exceed 200 characters");
      setUsername(e);
    }
    else {
      setUserNameErr("");
      setUsername(e);
    }

  }
  const ChangePassword = (e) => {
    if (e == "") {
      setPasswordErr("Password is required !");
      setPassword(e);
    } else {
      setPasswordErr("");
      setPassword(e);
    }

  }
  useEffect(() => {
    const keyDownHandler = e => {
      if (e.key === 'Enter') {
        e.preventDefault();
        // ️ call submit function here

        onSubmit();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [UserName, Password]);

  const onSubmit = () => {
    const details = {
      "userName": UserName,
      "password": Password
    }
    setSpinner(!open);
    axios
      .post(BaseUrl.login.loginRequest, details)
      .then((response) => {
        // console.log("this is the response for login: ", response);
        if (response?.data?.responseCode >= 0) {
          removeIncognitoEmail();
          setToken(response?.data?.data?.token);
          setUserName(response?.data?.data?.userName);
          setEmail(response?.data?.data?.email);
          setGlobalClientId(response?.data?.data?.globalClientId);
          setOrgId(response?.data?.data?.orgId);
          setOrgType(response?.data?.data?.orgType);
          setLocalMenus(response?.data?.data?.userMenus);
          setisEmp(response?.data?.data?.isEmployee);

          axios.get(apiinfo.dashboard.GetprequalificationStatuses)
            .then((res) => {
              if (res?.data?.status === true) {
                setstatuses(res?.data?.data);
              } else {
                alert(res.data.responseMessage);
              }
            })

          axios.get(BaseUrl.login.getAnnouncement)
            .then((response) =>
              response.data.headers > 0
                ? setCarouselFlag(true)
                : setCarouselFlag(false)
            );

          const URL = getInvitationURL();
          const VendorId = getInvitationVendorId();
          const CLIENTID = getInvitationClientId();
          const ISMultiClient = getInvitationIsMultiClient();
          const InvitationPqid = getInvitationPqid();

          const allowedPath = ["/registration-company"];
          const PageName = (!URL || URL == "null" || URL == "/login?registered=success") ? (!(response?.data?.data?.isEmployee) || response?.data?.data?.isEmployee == false ? "/DashBoard" : "/EmployeeSignature") : ((URL && VendorId != 'null' && URL?.indexOf(allowedPath) !== -1) ? "/DashBoard" : (URL == "/TemplatesList" ? (URL + "?InvitationClient=" + CLIENTID + "&InvitationVendor=" + VendorId + "&InvitationIsMultiClient=" + ISMultiClient + "&pqid=" + InvitationPqid) : URL));
          navigate(PageName);
          //navigate(response?.data?.data?.userMenus[0]?.actionName)
        } else {
          setSpinner(open);
          toast.error(response.data.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

        }
      });

  };



  // const sendLoginHelpRequest = () => {
  //   let item = {
  //     name: "User1",
  //     phoneNumber: "1234678973454",
  //     email: "test@test.com",
  //     comments: "test comment",
  //   };

  //   axios
  //     .post(BaseUrl.baseUrl + BaseUrl.login.loginHelp, item, BaseUrl.apiHeaders)
  //     .then((response) => {
  //       setOpen(true);
  //       console.log("this is the response for login help: ", response);
  //     });
  // };

  const [values, setValues] = React.useState({
    password: '',
    showPassword: false,
  });
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [spinner, setSpinner] = React.useState(false);
  const SpinnerClose = () => {
    setSpinner(false);
  };
  const handleToggle = () => {
    setSpinner(!open);
  };

  return (
    <>

      <div className="first-verify__loginContainer">
        <div className="first-verify__leftContainer">
          <div className="first-verify__logo"></div>
          <ToastContainer />

          {/* <Snackbar
            open={openError}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert severity="error" onClose={handleClose}>
              {props.content.loginPage.ErrorHandlerText}
            </Alert>
            <Alert
              onClose={handleClose}
              severity="success"
              sx={{ width: "100%" }}
            >
              Registration Successful!
              {props.content.loginPage.registrationSuccessful}
            </Alert>
          </Snackbar> */}
          <div className="first-verify__loginSubContainer">
            <span className="first-verify__loginHeading padding-top-10">
              {props.content.loginPage.loginHeading.Heading1}
            </span>
            <span className="first-verify__loginSubheading padding-top-10">
              {props.content.loginPage.loginHeading.Heading2}
            </span>
            <div className="first-verify__logindetails">
              <span className="username-label padding-top-10">
                {props.content.loginPage.inputLabel.userName}
              </span>
              <TextField
                id="outlined-basic"
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                inputProps={{ className: "login-user" }}
                // error={errors.firstName ? true : false}
                // {...register("userName")}
                value={UserName}
                onChange={(e) => ChangeUserName(e.target.value)}
                placeholder={props.content.loginPage.userIdPlaceholder}
                variant="outlined"
                required
              />
              <Typography className="asterisk-red">
                {UserNameErr}
              </Typography>
              <span className="password-label">
                {props.content.loginPage.inputLabel.password}
              </span>
              <FormControl sx={{ width: '378px' }} variant="outlined">
                <OutlinedInput
                  id="outlined-basic"
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  type={values.showPassword ? 'text' : 'password'}
                  inputProps={{ className: "login-password" }}
                  // error={errors.firstName ? true : false}
                  // {...register("password")}
                  value={Password}
                  onChange={(e) => ChangePassword(e.target.value)}
                  placeholder={props.content.loginPage.passwordPlaceholder}
                  variant="outlined"
                  required
                  endAdornment={
                    <InputAdornment position="end" sx={{
                      '&$focused $notchedOutline': {
                        borderColor: '#2EFF22',
                        borderWidth: 1,
                      },
                    }}>
                      <IconButton
                        id="outlined-basic"
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Typography className="asterisk-red">
                {PasswordErr}
              </Typography>
            </div>
            <div className="first-verify__logindetails padding-top-0">
              <FormControlLabel
                sx={{ marginLeft: "unset" }}
                control={<Checkbox />}
                label={props.content.loginPage.inputSubOptions.rememberme}
              />
              <Button
                variant="text"
                className="button-forgetPassword"
                sx={{ color: "#2A93DB", fontWeight: 500, textTransform: "capitalize" }}
                onClick={() => navigate("/forgot-password")}
              >
                {props.content.loginPage.inputSubOptions.forgetPassword}
              </Button>
              {/* <Button
                
                 variant="contained"
                sx={{ color: "#2A93DB", fontWeight: 500, textTransform: "capitalize" }}
                onClick={changeLocale}
              >
                Language
              </Button> */}
            </div>
            <div className="first-verify__logindetails padding-top-0">
              <Button
                sx={{ padding: "15px", textTransform: "capitalize" }}
                variant="contained"
                role="primary"
                className="login-button"
                onClick={onSubmit}
              >
                {props.content.loginPage.inputSubOptions.loginbutton}
              </Button>

              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </div>



            <div className="first-verify__logindetails padding-top-10 text-align-center">
              {props.content.loginPage.subLabels.noaccount}
              <Button
                variant="text"
                sx={{ color: "#2A93DB", fontWeight: 500, textTransform: "capitalize" }}
                onClick={() => navigate("/registration-option")}
              >
                {props.content.loginPage.subLabels.signup}
              </Button>
            </div>

            <div className="first-verify__logindetails padding-top-10 text-align-center">
              <Button
                variant="text"
                sx={{
                  backgroundColor: "#EFF8FF",
                  color: "#2A93DB",
                  fontWeight: 500,
                  textTransform: "capitalize"
                }}
                onClick={handleClickOpen}
              >
                <HelpIcon color="primary" fontSize="small" />
                {props.content.loginPage.subLabels.loginHelp}
              </Button>
              <Dialog open={open} onClose={handleClose}>
                <DialogTitle
                  sx={{
                    textAlign: "center",
                    fontWeight: 600,
                    marginTop: 3,
                    fontSize: 20,
                  }}
                >
                  Login Help
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <span className="red-color"><CloseIcon /></span>
                </IconButton>


                <Loginhelp close={handleClose} />
              </Dialog>
            </div>
          </div>
          <Footer />
        </div>
        <div className="first-verify__rightContainer">
          <div className="first-verify__rightSubContainer">
            <div className="first-verify__carousel-container">
              <Carousel displayFlag={carouselFlag} />

            </div>
          </div>
          {/* <div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  backgroundColor: '#f0f4f8',
  padding: '4%',
  backgroundImage: `url(${Img})`,
  backgroundSize: "cover"
}}>
  <div style={{
    // backgroundColor: '#2A93DB',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    borderRadius: '20px',
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
    // transition: 'transform 0.3s ease-in-out',
  }}>
    <div className="text-center" style={{
      backgroundColor: '#fff',
      color: '#d9534f',
      borderRadius: '10px',
      padding: '40px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      maxWidth: '600px',
      transform: 'scale(1)',
      // transition: 'transform 0.3s ease-in-out',
    }}>
      <span style={{
        fontWeight: '700',
        fontSize: '36px',
        marginBottom: '20px',
        animation: 'fadeIn 1s ease-in-out',
      }}>STOP!</span>
      <span style={{
        fontWeight: '400',
        fontSize: '20px',
        marginBottom: '10px',
        animation: 'fadeIn 1.5s ease-in-out',
      }}>This site is not live.</span>
      <span style={{
        fontWeight: '400',
        fontSize: '20px',
        animation: 'fadeIn 2s ease-in-out',
      }}>Log in here - <a href="https://pq.firstverify.com" style={{
       
        textDecoration: 'underline',
        fontWeight: '500',
      }}>https://pq.firstverify.com</a></span>
    </div>
  </div>
</div> */}

        </div>
      </div>

    </>
  );
}
export default Login;
